const axios = require('axios')
const $ = jQuery
require('jquery-serializejson')
require('jQuery.print')
import 'url-search-params-polyfill';
import 'promise-polyfill/src/polyfill';
import 'select2';
import 'select2/dist/css/select2.css';


$(document).on('change', '.js-selectAllApplications', function() {
    const $this = $(this);
    const $allCheckboxes = $('.js-applications-table tbody .h-checkbox__input');
    if ( $allCheckboxes.length < 1 ) {
        return;
    }
    if ( $this.is(':checked') ) {
        $allCheckboxes.each( function() {
            $(this).prop('checked', true);
        });
        updateSelectAllParameter()
    } else {
        $allCheckboxes.each( function() {
            $(this).prop('checked', false);
        });
        updateSelectAllParameter(false)
    }
});

$('.js-applications-table tbody .h-checkbox__input').on('change', function() {
    const $this = $(this);
    if ( $this.is(':checked') ) {
        updateSelectParameter($this.attr('name'), true);
    } else {
        updateSelectParameter($this.attr('name'), false);
    }
});

function updateSelectParameter(value, select) {
    let url = new URL(window.location.href);

    const applicationId = value.match(/selected-applications\[(\d+)]/);
    let id = null;

    if (applicationId === null) {
        return;
    } else {
        id = applicationId[1]
    }

    if ( !select ) {
        updateSelectAllParameter(false);
    }

    const excludeParams = url.searchParams.get('exclude');
    const excludeArray = excludeParams ? ( excludeParams.indexOf(',') !== -1  ?  excludeParams.split(',') : [ excludeParams ] ) : [];

    const selectedParams = url.searchParams.get('selected');
    const selectedArray = selectedParams ? ( selectedParams.indexOf(',') !== -1  ?  selectedParams.split(',') : [ selectedParams ] ) : [];

    let filteredExcludeArray = [];
    let filteredSelectedArray = [];

    if ( !select ) {
        filteredExcludeArray = [ ...excludeArray, id ];
        filteredSelectedArray = selectedArray.filter( x => x !== id)
    } else {
        filteredExcludeArray = excludeArray.filter( x => x !== id);
        filteredSelectedArray = [ ...selectedArray, id ]
    }
    let uniqueArray = [...new Set(filteredExcludeArray)];
    const exclude = uniqueArray.join(',');
    url.searchParams.set('exclude', exclude);

    let uniqueSelectedArray = [...new Set(filteredSelectedArray)];
    const selected = uniqueSelectedArray.join(',');
    url.searchParams.set('exclude', exclude);
    url.searchParams.set('selected', selected);

    const newUrl = url.origin + url.pathname + '?' + url.searchParams.toString();
    history.pushState(null, null, newUrl);
    updatePagination();
}

function updateSelectAllParameter(select = true) {
    let url = new URL(window.location.href);
    if ( select ) {
        url.searchParams.set('selectall', 1)
    } else {
        url.searchParams.delete('exclude');
        url.searchParams.delete('selected');
        url.searchParams.set('selectall', 0)
    }
    const newUrl = url.origin + url.pathname + '?' + url.searchParams.toString();
    history.pushState(null, null, newUrl);
    updatePagination();
}

function updatePagination() {
    const $buttons = $('.h-pagination a');

    if ( $buttons.length < 1 ) {
        return
    }

    $buttons.each(function () {
        const url = new URL(window.location.href);
        const $this = $(this);
        const pagerUrlAttribute = $this.attr('href')

        if (pagerUrlAttribute) {
            const newPage = new URL(pagerUrlAttribute).searchParams.get("page");
            if (newPage) {
                url.searchParams.set('page', newPage );
            }
        }
        const newUrl = url.origin + url.pathname + '?' + url.searchParams.toString();
        $this.attr('href', newUrl);
    })
}

function getParams(param) {
    const url = new URL(window.location.href);
    return url.searchParams.getAll(param);
}

function getSelectedApplications() {

    const url = new URL(window.location.href);

    let applications = [];

    const selectedParams = url.searchParams.get('selected');
    applications = selectedParams ? ( selectedParams.indexOf(',') !== -1  ?  selectedParams.split(',') : [ selectedParams ] ) : [];

    if ( applications.length === 0 ) {
        $('.js-applications-table input[name^="selected-applications"]').each(function() {
            const $checkbox = $(this);
            if ($checkbox.prop('checked')) {
                const applicationId = $checkbox.attr('name').match(/selected-applications\[(\d+)]/)
                if (applicationId !== null) {
                    applications.push(applicationId[1])
                }
            }
        })
    }
    return applications;
}

$('.js-export-budgets').click(e => {
    e.preventDefault();

    const selectedApplications = getSelectedApplications();

    if (selectedApplications.length === 0) {
        return
    }

    const params = new URLSearchParams

    selectedApplications.forEach(id => params.append('applications[]', id))

    params.set('application_type', getParams('application_type'));
    params.set('selectall', getParams('selectall'));
    params.set('exclude', getParams('exclude'));
    params.set('selected', getParams('selected'));

    window.location.href = `/workflow/applications/export-budgets?${params.toString()}`
})

$('.js-export-scores').click(e => {
    e.preventDefault()

    const selectedApplications = getSelectedApplications()

    if (selectedApplications.length === 0) {
        return
    }

    const params = new URLSearchParams

    selectedApplications.forEach(id => params.append('applications[]', id))

    params.set('application_type', getParams('application_type'));
    params.set('selectall', getParams('selectall'));
    params.set('exclude', getParams('exclude'));
    params.set('selected', getParams('selected'));

    window.location.href = `/workflow/applications/export-scores?${params.toString()}`
})

$('.js-export-pdf').click((e) => {
    e.preventDefault()

    const selectedApplications = getSelectedApplications()
    const params = new URLSearchParams

    selectedApplications.forEach(id => params.append('applications[]', id))

    params.set('application_type', getParams('application_type'));
    params.set('selectall', getParams('selectall'));
    params.set('exclude', getParams('exclude'));
    params.set('selected', getParams('selected'));

    window.location.href = `/workflow/applications/download-pdf?${params.toString()}`
})

$('.js-print-application').click(e => {
    e.preventDefault()

    const selectedApplications = getSelectedApplications()
    const params = new URLSearchParams

    selectedApplications.forEach(id => params.append('applications[]', id))

    params.set('application_type', getParams('application_type'));
    params.set('selectall', getParams('selectall'));
    params.set('exclude', getParams('exclude'));
    params.set('selected', getParams('selected'));

    axios.get(`/workflow/applications/print?${params.toString()}`)
        .then(({data}) => $.print(data))
})

$('.js-archive-applications').submit(e => {
    e.preventDefault()

    const $form = $('.js-archive-applications')
    const selected = getSelectedApplications()

    $form.find('input[name^="applications"]').detach()

    selected.forEach((id, index) => {
        $form.append(`<input type="hidden" name="applications[${index}]" value="${id}">`)
    })

    $form.get(0).submit()
})

$('.js-restore-applications').submit(e => {
    e.preventDefault()

    const $form = $('.js-restore-applications')
    const selected = getSelectedApplications()

    $form.find('input[name^="applications"]').detach()

    selected.forEach((id, index) => {
        $form.append(`<input type="hidden" name="applications[${index}]" value="${id}">`)
    })

    $form.get(0).submit()
})

$(document).on('show.bs.modal', '#invite-evaluators-modal', e => {
    const selected = getSelectedApplications()

    if (selected.length === 0) {
        // Don't allow modal to open if no applications are selected
        e.preventDefault()
    }
})

const inviteEvaluatorsModal = $('.js-inviteEvaluatorsModal__evalutatorsDropdown');

if ( inviteEvaluatorsModal.length > 0) {
    inviteEvaluatorsModal.select2({
        closeOnSelect : false,
        placeholder : "Select",
        allowHtml: true,
        allowClear: true,
        tags: true
    });
}

$('#invite-evaluators-form').submit((e) => {
    e.preventDefault();

    const formData = $(e.target).serializeJSON()
    const evaluatorIndex = Object.keys(formData.first_name)

    let applications = [];
    const invitations = [];

    const selectedApplications = getSelectedApplications();
    const params = new URLSearchParams;

    selectedApplications.forEach(id => params.append('applications[]', id))

    params.set('selectall', getParams('selectall'));
    params.set('exclude', getParams('exclude'));
    params.set('selected', getParams('selected'));

    axios.get(`/workflow/selected_applications?${params.toString()}`)
        .then(response => {
            applications = response.data;
            if ( !applications.length ) {
                return;
            }
            applications.forEach(applicationId => {
                evaluatorIndex.forEach(index => {
                    const forename = formData.first_name[index];
                    const surname = formData.surname[index];
                    const email = formData.email[index];

                    // since We got a dropdown for active evaluators, this repeater field does not have be to filled
                    if ( forename && surname && email) {
                        invitations.push({
                            application_id: applicationId,
                            first_name: forename,
                            surname: surname,
                            email: email,
                        })
                    }
                });

                // get a selected data from evaluators dropdown
                const dropdownOptions = inviteEvaluatorsModal.select2('data');
                if ( dropdownOptions ) {
                    dropdownOptions.forEach(option => {
                        const { forename, surname, email} = option.element.dataset;

                        invitations.push({
                            application_id: applicationId,
                            first_name: forename,
                            surname: surname,
                            email: email,
                        })
                    });
                }

            })

            axios.post('/workflow/invitations', {
                invitations: invitations,
            })
                .then((response) => {
                    window.location.href = '/workflow/applications?sent-invitations'
                })
                .catch((error) => {
                    window.location.href = '/workflow/applications?invitations-error'
                    throw error
                })
        });
});

let activeForm

$('.js-delete-application-form').submit(e => {
    e.preventDefault()
    activeForm = e.target
})

$('.js-confirm-delete-application-modal .btn-primary').click(e => {
    activeForm.submit()
})

$('.js-confirmScoresModal__submitBtn').click(() => {
    $('#submit_evalutation').submit()
});

$('.js-submitValidationForm .js-submitValidationForm__updateBtn').click(function(e) {
    e.preventDefault();
    const $form = $(this).closest('.js-submitValidationForm');
    if ( $form.length < 1 ) {
        return
    }
    let url = $form.attr('action');
    const newAction = `${url}/update`;
    $form.attr('action', newAction);
    $form.submit();
});

// replace textareas with normal div on pdf and prints
$('.js-pdf textarea').each(function( i, el ) {
    $(el).replaceWith('<div class="h-pdf__textBox">'+$(el).text().replace(/\r?\n/g, '<br />')+'</div>');
})
